export default "__VITE_ASSET__BGuChKAC__"